import { Box, Heading, Stack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { PortalSourcingEventDetailDto } from "../../../../autogen/bff-api";
import { ChangeLogEntry } from "../../../v2/sourcing-event/changes/ChangeLogEntry";
import { isPrivatePortalEvent } from "./PrivateInviteCta";

interface Props {
  event: PortalSourcingEventDetailDto;
}

export const EventChangeLogSection = ({ event }: Props) => {
  const { t } = useTranslation();
  const changeLog = event.changeLog ?? [];
  if (changeLog.length === 0) return null;

  const newestFirst = [...changeLog].sort((a, b) =>
    (b.publishedAt ?? b.createdAt).localeCompare(a.publishedAt ?? a.createdAt),
  );

  return (
    <Box borderWidth="1px" borderColor="smBorder" borderRadius="xl" bg="white" p="6">
      <Heading as="h3" size="sm" mb="4">
        {isPrivatePortalEvent(event) ? t("Changes to the request") : t("Changes to the announcement")}
      </Heading>
      <Stack spacing="3">
        {newestFirst.map((revision) => (
          <Box key={revision.id} borderLeftWidth="3px" borderColor="smPrimary" pl="4">
            <ChangeLogEntry revision={revision} />
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
